export default {
  0: 'NA_INDOOR_SLABS',
  1: 'NA_INDOOR_BIG_BLOCKS',
  2: 'NA_INDOOR_SMALL_BLOCKS_65',
  3: 'GENERIC',
  4: 'GRODAN_ELITE',
  5: 'GRODAN_GT_MASTER_100',
  6: 'GRODAN_GT_MASTER_75',
  7: 'GRODAN_GT_MASTER_DRY',
  8: 'GRODAN_PRESTIGE_100',
  9: 'GRODAN_PRESTIGE_85',
  10: 'GRODAN_PRESTIGE_75',
  11: 'GRODAN_GT_EXPERT_100',
  12: 'GRODAN_GT_EXPERT_75',
  13: 'GRODAN_SUPREME',
  14: 'GRODAN_VITAL',
  15: 'GRODAN_VITAL_DRY',
  16: 'GRODAN_CLASSIC',
  17: 'GRODAN_CLASSIC_MY_100',
  18: 'GRODAN_CLASSIC_MY_75',
  19: 'GRODAN_VITAFLOR_100',
  20: 'GRODAN_VITAFLOR_75',
  21: 'FLORTOP_ROSA',
  22: 'PROPAGATION_BLOCK',
  23: 'OTHER_MINERAL_WOOL_100',
  24: 'OTHER_MINERAL_WOOL_75',
  25: 'SLAB_BY_DEFAULT',
  26: 'GRODAN_OPTIONAL_1',
  27: 'GRODAN_OPTIONAL_2',
  28: 'NA_INDOOR_SLABS_75',
}

export const slabTypeNames = {
  GRODAN_ELITE: 'Grodan Elite',
  GRODAN_GT_MASTER_100: 'Grodan GT Master 100',
  GRODAN_GT_MASTER_75: 'Grodan GT Master 75',
  GRODAN_GT_MASTER_DRY: 'Grodan GT Master Dry',
  GRODAN_PRESTIGE_100: 'Grodan Prestige 100',
  GRODAN_PRESTIGE_85: 'Grodan Prestige 85',
  GRODAN_PRESTIGE_75: 'Grodan Prestige 75',
  GRODAN_GT_EXPERT_100: 'Grodan GT Expert 100',
  GRODAN_GT_EXPERT_75: 'Grodan GT Expert 75',
  GRODAN_SUPREME: 'Grodan Supreme',
  GRODAN_VITAL: 'Grodan Vital',
  GRODAN_VITAL_DRY: 'Grodan Vital Dry',
  GRODAN_CLASSIC: 'Grodan Classic',
  GRODAN_CLASSIC_MY_100: 'Grodan Classic More Year 100',
  GRODAN_CLASSIC_MY_75: 'Grodan Classic More Year 75',
  GRODAN_VITAFLOR_100: 'Grodan Vitaflor 100',
  GRODAN_VITAFLOR_75: 'Grodan Vitaflor 75',
  FLORTOP_ROSA: 'Flortop Rosa',
  PROPAGATION_BLOCK: 'Propagation block',
  NA_INDOOR_BIG_BLOCKS: 'MJ big blocks',
  NA_INDOOR_SMALL_BLOCKS_65: 'MJ small blocks',
  NA_INDOOR_SLABS: 'MJ slabs 100',
  NA_INDOOR_SLABS_75: 'MJ slabs 75',
  OTHER_MINERAL_WOOL_100: 'Other mineral wool 100',
  OTHER_MINERAL_WOOL_75: 'Other mineral wool 75',
  SLAB_BY_DEFAULT: 'Slab by default',
  GRODAN_OPTIONAL_1: 'Grodan optional slab 1',
  GRODAN_OPTIONAL_2: 'Grodan optional slab 2',
  GENERIC: 'Generic'
}